const FULLSCREEN_FALLBACK_CLASS = 'fullscreen'

export const requestFullscreen = (element: HTMLElement): void => {
  if (typeof element.requestFullscreen !== 'function') {
    element.classList.add(FULLSCREEN_FALLBACK_CLASS)
    return
  }

  element.requestFullscreen().catch(() => element.classList.add(FULLSCREEN_FALLBACK_CLASS))
}

export const exitFullscreen = (element: HTMLElement): void => {
  element.classList.remove(FULLSCREEN_FALLBACK_CLASS)

  if (document.fullscreenElement === element) {
    document.exitFullscreen()
  }
}
